import { Department } from 'services/api/types';

const departments: Department[] = [
  {
    name: 'Department A',
    id: 100,
    total_users: 996
  },
  {
    name: 'Department B',
    id: 101,
    total_users: 997
  },
  {
    name: 'Department C',
    id: 102,
    total_users: 998
  },
  {
    name: 'Department D',
    id: 103,
    total_users: 999
  }
];

export default departments;
